/**
 * @generated SignedSource<<1ccac0f49398dffedea1b7c9d33a3afe>>
 * @relayHash b05a91d049fef94f34c3b4cd59c28e4f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b05a91d049fef94f34c3b4cd59c28e4f

import { ConcreteRequest } from 'relay-runtime';
export type medicationNewsTooltipQuery$variables = {
  id: number;
};
export type medicationNewsTooltipQuery$data = {
  readonly ch_medicationNews: ReadonlyArray<{
    readonly leadText: string;
    readonly publicationDate: string;
    readonly subjectArea: {
      readonly description: string;
      readonly id: string;
    };
    readonly title: string;
  }>;
};
export type medicationNewsTooltipQuery = {
  response: medicationNewsTooltipQuery$data;
  variables: medicationNewsTooltipQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "itemId",
        "variableName": "id"
      }
    ],
    "concreteType": "DocumedisProductNews",
    "kind": "LinkedField",
    "name": "ch_medicationNews",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "leadText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicationDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DocumedisProductNewsSubjectArea",
        "kind": "LinkedField",
        "name": "subjectArea",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "medicationNewsTooltipQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "medicationNewsTooltipQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "b05a91d049fef94f34c3b4cd59c28e4f",
    "metadata": {},
    "name": "medicationNewsTooltipQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "81ef85403e5f70c4483cd7db912f4f41";

export default node;
